export enum ProcessorsNameEnum {
  KUSHKI_PROCESSOR = "Kushki Acquirer Processor",
}
